export default {
  icons: [],
  iconGalleries: {
    'point': [],
    'info': [],
    'image': []
  },
  iconsFetched: false
}



// WEBPACK FOOTER //
// ./src/components/icon/store/state.js